<h1 mat-dialog-title>{{ 'Step' | translate }}</h1>
<div mat-dialog-content>
  <div *ngIf="data.seeks" class="seek-time">
    {{ 'From' | translate }} {{Utils().getTime(Utils().getTime2Hours(data.seeks.seekStart), Utils().getTime2Minutes(data.seeks.seekStart), Utils().getTime2Seconds(data.seeks.seekStart))}} {{ 'to' | translate }} {{Utils().getTime(Utils().getTime2Hours(data.seeks.seekEnd), Utils().getTime2Minutes(data.seeks.seekEnd), Utils().getTime2Seconds(data.seeks.seekEnd))}} ({{getStepDuration()}} {{ 'seconds' | translate }})
  </div>
  <mat-form-field>
    <mat-label>{{ 'Title' | translate }}</mat-label>
    <input matInput [(ngModel)]="data.title">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'Description' | translate }}</mat-label>
    <textarea matInput [(ngModel)]="data.description" [ngStyle]="{height: '150px'}"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions class="actions">
  <button mat-stroked-button (click)="onNoClick()">{{ 'Cancel' | translate }}</button>
  <div>
    <button *ngIf="!data.isNew" mat-flat-button color="warn" (click)="remove()">{{ 'Remove' | translate }}</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>{{ 'Save' | translate }}</button>
  </div>
</div>
